import { buildApiUrl } from '../api.utils';
import { AuthorizedRequest } from '../common.types';
import { LoginCredentials } from './api.types';

/** Отправляет запрос на авторизацию оператора. */
export function loginOperator(credentials: LoginCredentials): Promise<Response> {
  return fetch(buildApiUrl('/api/auth/login'), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(credentials)
  });
}

/** Пытается восстановить текущую refresh-сессию оператора. */
export function requestSessionRefresh(): Promise<Response> {
  return fetch(buildApiUrl('/api/auth/refresh'), {
    method: 'POST',
    credentials: 'include'
  });
}

/** Корректно завершает операторскую сессию через защищённый API-клиент. */
export function logoutOperator(performAuthorizedRequest: AuthorizedRequest): Promise<Response> {
  return performAuthorizedRequest('/api/auth/logout', {
    method: 'POST'
  });
}